/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Segment, Grid, Divider, Header, List, Popup,
  Button, Icon, Dimmer, Loader
} from "semantic-ui-react";
import { connect } from "react-redux";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ProblemCard from "./ProblemCard";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import TsExpertReport from "./TsExpertReport";
import Utils from "../utilities/Utils";
import { solveProblemAction } from "../../actions/changeActiveItemActions";

const UtilsInstance = new Utils();

export class TSExpert extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      nowMillis: Date.now(),
      lastUpdate: new Date(),
      networkTag: "",
      uptime: "",
      problems: [],
      groupedProblems: {
        "retry": [],
        "diagnostic": [],
        "fault": [],
        "faultSequence": [],
        "errorConfig": [],
        "errorParam": [],
        "missing": [],
        "online": [],
        "automaticBlacklist": [],
        "masterFault": [],
        "fiberLowerLimitMaintenanceRequired": [],
        "fiberLowerLimitUrgentMaintenance": [],
        "fiberSignalLost": []
      },
      currentProblemType: "",
      currentProblemList: [],
      // The report
      report: "",
      isGenerateReportDimmerActive: false,
    };
  }

  retrieveData = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "tsExpert", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "fiber/tsExpert", { mode: "cors" })
        .then(UtilsInstance.checkStatus)
        .then(res => res.json())
        .then(data => data)
        .catch(() => {
          return [];
        })
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    this.setState({
      problems: [...resolvedPromisses[0], ...resolvedPromisses[1]],
    }, () => {
      this.checkProblemsListSize();
      this.groupProblemsByType();
    });
  }

  retrieveTagAndUptimeData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "homePage", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        networkTag: data.networkTag,
        uptime: this.formatToRelativeTime(data.uptime)
      }));
  }

  getDaysInMonth = (month, year) => {
    if (typeof year == "undefined") year = 1999; // any non-leap-year works as default     
    let currmon = new Date(year, month),
      nextmon = new Date(year, month + 1);
    return Math.floor((nextmon.getTime() - currmon.getTime()) / (24 * 3600 * 1000));
  }

  getDateTimeSince = (target) => { // target should be a Date object
    let now = new Date(), yd, md, dd, hd, nd, sd, out = [];

    yd = now.getFullYear() - target.getFullYear();
    md = now.getMonth() - target.getMonth();
    dd = now.getDate() - target.getDate();
    hd = now.getHours() - target.getHours();
    nd = now.getMinutes() - target.getMinutes();
    sd = now.getSeconds() - target.getSeconds();

    if (md < 0) { yd--; md += 12; }
    if (dd < 0) {
      md--;
      dd += this.getDaysInMonth(now.getMonth() - 1, now.getFullYear());
    }
    if (hd < 0) { dd--; hd += 24; }
    if (nd < 0) { hd--; nd += 60; }
    if (sd < 0) { nd--; sd += 60; }

    if (yd > 0) out.push(yd + Strings.YEAR + (yd === 1 ? "" : "s"));
    if (md > 0) {
      if (md === 1) {
        out.push(md + Strings.MONTH);
      }
      else {
        out.push(md + Strings.MONTHS);
      }
    }
    if (dd > 0) out.push(dd + Strings.DAY + (dd === 1 ? "" : "s"));
    if (hd > 0) out.push(hd + Strings.HOUR + (hd === 1 ? "" : "s"));
    if (nd > 0) out.push(nd + Strings.MINUTE + (nd === 1 ? "" : "s"));
    //if (sd > 0) out.push(sd + " segundo" + (sd === 1 ? "" : "s"));
    return out.join(" ");
  }

  formatToRelativeTime = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      const uptimeInMillis = uptimeInSeconds * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return this.getDateTimeSince(new Date(dateWhenWasTurnedOn));
    }
  }

  checkProblemsListSize = () => {
    if (this.state.problems.length > 0) {
      document.getElementById("problems-list").style.display = "block";
      document.getElementById("no-problem-detected-header").style.display = "none";
    }
    else {
      document.getElementById("problems-list").style.display = "none";
      document.getElementById("no-problem-detected-header").style.display = "block";
    }
  }

  groupProblemsByType = () => {
    let newGroupedProblems = {
      "retry": [],
      "diagnostic": [],
      "fault": [],
      "faultSequence": [],
      "errorConfig": [],
      "errorParam": [],
      "missing": [],
      "online": [],
      "automaticBlacklist": [],
      "masterFault": [],
      "fiberLowerLimitMaintenanceRequired": [],
      "fiberLowerLimitUrgentMaintenance": [],
      "fiberSignalLost": []
    };

    for (let i = 0; i < this.state.problems.length; i++) {
      if (this.state.problems[i].type === Constants.RETRIES_ERROR_TYPE) {
        newGroupedProblems.retry.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.DIAGNOSTIC_ERROR_TYPE) {
        newGroupedProblems.diagnostic.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.FAULT_ERROR_TYPE) {
        newGroupedProblems.fault.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.FAULT_SEQUENCE_ERROR_TYPE) {
        newGroupedProblems.faultSequence.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.CONFIG_ERROR_TYPE) {
        newGroupedProblems.errorConfig.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.PARAM_ERROR_TYPE) {
        newGroupedProblems.errorParam.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.MISSING_ERROR_TYPE) {
        newGroupedProblems.missing.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.ONLINE_ERROR_TYPE) {
        newGroupedProblems.online.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.CRITICAL_SLAVE_ERROR_TYPE) {
        newGroupedProblems.automaticBlacklist.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.MASTER_FAULT_ERROR_TYPE) {
        newGroupedProblems.masterFault.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE) {
        newGroupedProblems.fiberLowerLimitMaintenanceRequired.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE) {
        newGroupedProblems.fiberLowerLimitUrgentMaintenance.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
        newGroupedProblems.fiberSignalLost.push(this.state.problems[i]);
      }
    }

    this.setState({ groupedProblems: newGroupedProblems });
  }

  // ------ Events List ------
  getListItem = (problemType, groupedProblemList) => {
    if (groupedProblemList.length > 0) {
      return (
        <List.Item>
          <List.Content floated='right' style={{ marginTop: "4px" }}>
            <Button
              size="tiny"
              circular
              color="teal"
              icon="chevron right"
              onClick={this.handleDetailsButtonClick(problemType, groupedProblemList)} />
          </List.Content>
          {this.getListContent(problemType)}
        </List.Item>
      );
    }
    else {
      return "";
    }
  }

  handleDetailsButtonClick = (problemType, groupedProblemList) => () => {
    this.setState({
      currentProblemType: problemType,
      currentProblemList: groupedProblemList
    }, () => {
      document.getElementById("no-task-selected-header").style.display = "none";
      document.getElementById("task-details").style.display = "block";
    });
  }

  getListContent = (problemType) => {
    if (problemType === Constants.RETRIES_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.RETRIES_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    if (problemType === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.DIAGNOSTIC_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.FAULT_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.FAULT_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.FAULT_SEQUENCE_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.FAULT_SEQ_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.CONFIG_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.CONFIG_ERROR_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.PARAM_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.PARAM_ERROR_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.MISSING_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.MISSING_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.ONLINE_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.ONLINE_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.CRITICAL_SLAVE_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.CRITICAL_SLAVE_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.MASTER_FAULT_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.MASTER_FAULT_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.FIBER_SIGNAL_LOSS_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
  }

  // ------ Actions ------
  getActions = () => {
    if (this.state.currentProblemType === Constants.RETRIES_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.RETRIES_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>
            {Strings.RETRIES_SUGGESTION_2}
          </p>
          <ol type="a">
            <li>{Strings.RETRIES_SUGGESTION_4}</li>
            <ol type="i">
              <li>{Strings.RETRIES_SUGGESTION_5}</li>
              <li>{Strings.RETRIES_SUGGESTION_6}</li >
              <li>{Strings.RETRIES_SUGGESTION_7}</li>
              <li>{Strings.RETRIES_SUGGESTION_8}</li>
              <li>{Strings.RETRIES_SUGGESTION_9}</li>
            </ol>
            <li>{Strings.RETRIES_SUGGESTION_10}</li>
            <li>{Strings.RETRIES_SUGGESTION_11}</li>
            <li>{Strings.RETRIES_SUGGESTION_12}</li>
            <li>{Strings.RETRIES_SUGGESTION_13}</li>
          </ol>
          <p style={{ textAlign: "justify" }}>
            <b>{Strings.PS}</b> {Strings.RETRIES_SUGGESTION_14}
          </p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.DIAGNOSTIC_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>
            {Strings.DIAGNOSTIC_SUGGESTION_2}
          </p>
          <ol type="a">
            <li>{Strings.DIAGNOSTIC_SUGGESTION_3}</li>
            <li>{Strings.DIAGNOSTIC_SUGGESTION_4}</li>
          </ol>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.FAULT_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.FAULT_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>
            {Strings.FAULT_SUGGESTION_2}
          </p>
          <ol type="a">
            <li>{Strings.FAULT_SUGGESTION_3}</li>
            <li>{Strings.FAULT_SUGGESTION_4}</li>
            <li>{Strings.FAULT_SUGGESTION_5}</li>
            <li>{Strings.FAULT_SUGGESTION_6}</li>
          </ol>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.FAULT_SEQUENCE_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.FAULTS_SEQ_SUGGESTION_1}</Header>
          <ul type="a">
            <li>{Strings.FAULTS_SEQ_SUGGESTION_2}</li>
            <li>{Strings.FAULTS_SEQ_SUGGESTION_3}</li>
            <li>{Strings.FAULTS_SEQ_SUGGESTION_4}</li>
            <li>{Strings.FAULTS_SEQ_SUGGESTION_5}</li>
            <li>{Strings.FAULTS_SEQ_SUGGESTION_6}</li>
            <li>{Strings.FAULTS_SEQ_SUGGESTION_7}</li>
            <li>{Strings.FAULTS_SEQ_SUGGESTION_8}</li>
          </ul>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.CONFIG_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.CONFIG_ERROR_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>
            {Strings.CONFIG_ERROR_SUGGESTION_2}
          </p>
          <ol type="a">
            <li>{Strings.CONFIG_ERROR_SUGGESTION_3}</li>
          </ol>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.PARAM_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.PARAM_ERROR_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>
            {Strings.PARAM_ERROR_SUGGESTION_2}
          </p>
          <ol type="a">
            <li>{Strings.PARAM_ERROR_SUGGESTION_3}</li>
          </ol>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.MISSING_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.MISSING_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>
            {Strings.MISSING_SUGGESTION_2}
          </p>
          <ol type="a">
            <li>{Strings.MISSING_SUGGESTION_3}</li>
            <li>{Strings.MISSING_SUGGESTION_4}</li>
          </ol>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.ONLINE_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.ONLINE_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>
            {Strings.ONLINE_SUGGESTION_2}
          </p>
          <ol type="a">
            <li>{Strings.ONLINE_SUGGESTION_3}</li>
          </ol>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.CRITICAL_SLAVE_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.CRITICAL_SLAVE_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>
            {Strings.CRITICAL_SLAVE_SUGGESTION_2}
          </p>
          <ol type="a">
            <li>{Strings.CRITICAL_SLAVE_SUGGESTION_3}</li>
            <li>{Strings.CRITICAL_SLAVE_SUGGESTION_4}</li>
            <li>{Strings.CRITICAL_SLAVE_SUGGESTION_5}</li>
            <li>{Strings.CRITICAL_SLAVE_SUGGESTION_6}</li>
            <li>{Strings.CRITICAL_SLAVE_SUGGESTION_7}</li>
            <li>{Strings.CRITICAL_SLAVE_SUGGESTION_8}</li>
            <li>{Strings.CRITICAL_SLAVE_SUGGESTION_9}</li>
            <li>{Strings.CRITICAL_SLAVE_SUGGESTION_10}</li>
          </ol>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.MASTER_FAULT_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.MASTER_FAULT_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>
            {Strings.MASTER_FAULT_SUGGESTION_2}
          </p>
          <ol type="a">
            <li>{Strings.MASTER_FAULT_SUGGESTION_3}</li>
            <li>{Strings.MASTER_FAULT_SUGGESTION_4}</li>
            <li>{Strings.MASTER_FAULT_SUGGESTION_5}</li>
          </ol>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_1}</Header>
          <ul>
            <li>{Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_2}</li>
            <li>{Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_3}</li>
            <li>{Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_4}</li>
          </ul>
          <p style={{ textAlign: "justify" }}>{Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_5}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_1}</Header>
          <ul>
            <li>{Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_2}</li>
            <li>{Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_3}</li>
            <li>{Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_4}</li>
          </ul>
          <p style={{ textAlign: "justify" }}>{Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_5}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.FIBER_SIGNAL_LOSS_SUGGESTION_1}</Header>
          <ul>
            <li>{Strings.FIBER_SIGNAL_LOSS_SUGGESTION_2}</li>
            <li>{Strings.FIBER_SIGNAL_LOSS_SUGGESTION_3}</li>
            <li>{Strings.FIBER_SIGNAL_LOSS_SUGGESTION_4}</li>
          </ul>
        </Segment>
      );
    }
  }

  getProblemCards = () => {
    if (this.state.currentProblemList.length > 1 &&
      this.state.currentProblemType !== Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE &&
      this.state.currentProblemType !== Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE &&
      this.state.currentProblemType !== Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.DETAILING}</Header>
          {
            this.state.currentProblemList.map(problem => (
              <ProblemCard
                key={problem._id}
                nowMillis={this.state.nowMillis}
                problem={problem} />
            ))
          }
          <Button
            fluid
            color='green'
            onClick={this.handleBatchCheckButtonClick}>
            {Strings.BATCH_CHECK}
          </Button>
        </Segment>
      );
    }
    else {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.DETAILING}</Header>
          {
            this.state.currentProblemList.map(problem => (
              <ProblemCard
                key={problem._id}
                nowMillis={this.state.nowMillis}
                problem={problem} />
            ))
          }
        </Segment>
      );
    }
  }

  handleCloseButtonClick = () => {
    this.setState({
      currentProblemType: "",
      currentProblemList: []
    }, () => {
      document.getElementById("no-task-selected-header").style.display = "block";
      document.getElementById("task-details").style.display = "none";
    });
  }

  handleBatchCheckButtonClick = () => {
    let data = JSON.stringify({
      type: this.state.currentProblemType,
      problems: this.state.currentProblemList
    });

    fetch(Constants.REQUEST_IP_ADDRESS + "solveAllProblems_POST", {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data
    })
      .then(UtilsInstance.checkStatus2)
      .then(() => {
        alert(Strings.ALL_EVENTS_CHECKED);

        // Mostre que não existem eventos
        document.getElementById("no-task-selected-header").style.display = "block";
        document.getElementById("task-details").style.display = "none";

        // Limpe as variáveis de eventos e pegue os dados atualizados
        this.setState({
          currentProblemType: "",
          currentProblemList: [],
        }, () => {
          this.retrieveData();
        });
      })
      .catch((error) => {
        let result = JSON.parse(error.message);

        let message = "";

        if (result.notSolved.length > 0) {

          message += this.getInitialErrorMessage(result.type) + "\n";

          for (let i = 0; i < result.notSolved.length; i++) {
            message += this.getErrorMessage(result.notSolved[i]);
          }

        }

        alert(message);

        // Feche a seção de solução
        document.getElementById("no-task-selected-header").style.display = "block";
        document.getElementById("task-details").style.display = "none";

        // Limpe as variáveis de eventos e pegue os dados atualizados
        this.setState({
          currentProblemType: "",
          currentProblemList: [],
        }, () => {
          this.retrieveData();
        });

      });
  }

  getInitialErrorMessage = (problemType) => {
    if (problemType === Constants.RETRIES_ERROR_TYPE) {
      return Strings.RETRIES_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return Strings.DIAGNOSTIC_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.FAULT_ERROR_TYPE) {
      return Strings.FAULT_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.FAULT_SEQUENCE_ERROR_TYPE) {
      return Strings.FAULT_SEQ_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.CONFIG_ERROR_TYPE) {
      return Strings.CONFIG_ERROR_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.PARAM_ERROR_TYPE) {
      return Strings.PARAM_ERROR_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.MISSING_ERROR_TYPE) {
      return Strings.MISSING_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.ONLINE_ERROR_TYPE) {
      return Strings.ONLINE_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.CRITICAL_SLAVE_ERROR_TYPE) {
      return Strings.CRITICAL_SLAVE_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.MASTER_FAULT_ERROR_TYPE) {
      return Strings.MASTER_FAULT_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE) {
      return Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_ERROR_MSG;
    }
    else if (problemType === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE) {
      return Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_ERROR_MSG;
    }
    else if (problemType === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
      return Strings.FIBER_SIGNAL_LOSS_ERROR_MSG;
    }
    else {
      return "";
    }
  }

  getErrorMessage = (problem) => {
    if (problem.type === Constants.RETRIES_ERROR_TYPE) {
      return Strings._ADDRESS + problem.address + "\n";
    }
    else if (problem.type === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return Strings._ADDRESS + problem.address + "\n";
    }
    else if (problem.type === Constants.FAULT_ERROR_TYPE) {
      return Strings._ADDRESS + problem.address + "\n";
    }
    else if (problem.type === Constants.FAULT_SEQUENCE_ERROR_TYPE) {
      return Strings._ADDRESS + problem.address + "\n";
    }
    else if (problem.type === Constants.CONFIG_ERROR_TYPE) {
      return Strings._ADDRESS + problem.address + "\n";
    }
    else if (problem.type === Constants.PARAM_ERROR_TYPE) {
      return Strings._ADDRESS + problem.address + "\n";
    }
    else if (problem.type === Constants.MISSING_ERROR_TYPE) {
      return Strings._ADDRESS + problem.address + "\n";
    }
    else if (problem.type === Constants.ONLINE_ERROR_TYPE) {
      return Strings._ADDRESS + problem.address + "\n";
    }
    else if (problem.type === Constants.CRITICAL_SLAVE_ERROR_TYPE) {
      return Strings._ADDRESS + problem.address + "\n";
    }
    else if (problem.type === Constants.MASTER_FAULT_ERROR_TYPE) {
      return Strings._ADDRESS + problem.address + "\n";
    }
    else {
      return "";
    }
  }

  // ------ TS Expert Report ------
  generateTsExpertReport = () => {
    this.setState({ report: "" }, async () => {
      this.setGeneratingDimmerState(true);

      let promissesArray = [];

      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS + "tsExpert", { mode: "cors" })
          .then(res => res.json())
          .then(data => data)
      );

      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS + "fiber/tsExpert", { mode: "cors" })
          .then(UtilsInstance.checkStatus)
          .then(res => res.json())
          .then(data => data)
          .catch(() => {
            return [];
          })
      );

      let resolvedPromisses = await Promise.all(promissesArray);

      let problems = [...resolvedPromisses[0], ...resolvedPromisses[1]];

      let reportGroupedProblems = {
        "retry": [],
        "diagnostic": [],
        "fault": [],
        "faultSequence": [],
        "errorConfig": [],
        "errorParam": [],
        "missing": [],
        "online": [],
        "automaticBlacklist": [],
        "masterFault": [],
        "fiberLowerLimitMaintenanceRequired": [],
        "fiberLowerLimitUrgentMaintenance": [],
        "fiberSignalLost": []
      };

      for (let i = 0; i < problems.length; i++) {
        if (problems[i].type === Constants.RETRIES_ERROR_TYPE) {
          reportGroupedProblems.retry.push(problems[i]);
        }
        else if (problems[i].type === Constants.DIAGNOSTIC_ERROR_TYPE) {
          reportGroupedProblems.diagnostic.push(problems[i]);
        }
        else if (problems[i].type === Constants.FAULT_ERROR_TYPE) {
          reportGroupedProblems.fault.push(problems[i]);
        }
        else if (problems[i].type === Constants.FAULT_SEQUENCE_ERROR_TYPE) {
          reportGroupedProblems.faultSequence.push(problems[i]);
        }
        else if (problems[i].type === Constants.CONFIG_ERROR_TYPE) {
          reportGroupedProblems.errorConfig.push(problems[i]);
        }
        else if (problems[i].type === Constants.PARAM_ERROR_TYPE) {
          reportGroupedProblems.errorParam.push(problems[i]);
        }
        else if (problems[i].type === Constants.MISSING_ERROR_TYPE) {
          reportGroupedProblems.missing.push(problems[i]);
        }
        else if (problems[i].type === Constants.ONLINE_ERROR_TYPE) {
          reportGroupedProblems.online.push(problems[i]);
        }
        else if (problems[i].type === Constants.CRITICAL_SLAVE_ERROR_TYPE) {
          reportGroupedProblems.automaticBlacklist.push(problems[i]);
        }
        else if (problems[i].type === Constants.MASTER_FAULT_ERROR_TYPE) {
          reportGroupedProblems.masterFault.push(problems[i]);
        }
        else if (problems[i].type === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE) {
          reportGroupedProblems.fiberLowerLimitMaintenanceRequired.push(problems[i]);
        }
        else if (problems[i].type === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE) {
          reportGroupedProblems.fiberLowerLimitUrgentMaintenance.push(problems[i]);
        }
        else if (problems[i].type === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
          reportGroupedProblems.fiberSignalLost.push(problems[i]);
        }
      }

      this.setState({
        report:
          <TsExpertReport
            nowMillis={Date.now()}
            retry={reportGroupedProblems.retry}
            diagnostic={reportGroupedProblems.diagnostic}
            fault={reportGroupedProblems.fault}
            faultSequence={reportGroupedProblems.faultSequence}
            errorConfig={reportGroupedProblems.errorConfig}
            errorParam={reportGroupedProblems.errorParam}
            missing={reportGroupedProblems.missing}
            online={reportGroupedProblems.online}
            automaticBlacklist={reportGroupedProblems.automaticBlacklist}
            masterFault={reportGroupedProblems.masterFault}
            fiberLowerLimitMaintenanceRequired={reportGroupedProblems.fiberLowerLimitMaintenanceRequired}
            fiberLowerLimitUrgentMaintenance={reportGroupedProblems.fiberLowerLimitUrgentMaintenance}
            fiberSignalLost={reportGroupedProblems.fiberSignalLost}
          />
      });
    });
  }

  setGeneratingDimmerState = (isActive) => {
    if (!isActive) {
      this.setState({ isGenerateReportDimmerActive: isActive }, () => {
        alert(Strings.GENERATING_ACTIONS_LIST_SUCCESS);
      });
    }
    else {
      this.setState({ isGenerateReportDimmerActive: isActive });
    }
  }

  // ------ TS Expert Modal ------
  retrieveData2 = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "tsExpert", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "fiber/tsExpert", { mode: "cors" })
        .then(UtilsInstance.checkStatus)  
        .then(res => res.json())
        .then(data => data)
        .catch(() => {
          return [];
        })
    );

    let resolvedPromisses = await Promise.all(promissesArray);
    let problems = [...resolvedPromisses[0], ...resolvedPromisses[1]];

    if (problems.length > 0) {
      document.getElementById("problems-list").style.display = "block";
      document.getElementById("no-problem-detected-header").style.display = "none";

      let newGroupedProblems = {
        "retry": [],
        "diagnostic": [],
        "fault": [],
        "faultSequence": [],
        "errorConfig": [],
        "errorParam": [],
        "missing": [],
        "online": [],
        "automaticBlacklist": [],
        "masterFault": [],
        "fiberLowerLimitMaintenanceRequired": [],
        "fiberLowerLimitUrgentMaintenance": [],
        "fiberSignalLost": []
      };

      for (let i = 0; i < problems.length; i++) {
        if (problems[i].type === Constants.RETRIES_ERROR_TYPE) {
          newGroupedProblems.retry.push(problems[i]);
        }
        else if (problems[i].type === Constants.DIAGNOSTIC_ERROR_TYPE) {
          newGroupedProblems.diagnostic.push(problems[i]);
        }
        else if (problems[i].type === Constants.FAULT_ERROR_TYPE) {
          newGroupedProblems.fault.push(problems[i]);
        }
        else if (problems[i].type === Constants.FAULT_SEQUENCE_ERROR_TYPE) {
          newGroupedProblems.faultSequence.push(problems[i]);
        }
        else if (problems[i].type === Constants.CONFIG_ERROR_TYPE) {
          newGroupedProblems.errorConfig.push(problems[i]);
        }
        else if (problems[i].type === Constants.PARAM_ERROR_TYPE) {
          newGroupedProblems.errorParam.push(problems[i]);
        }
        else if (problems[i].type === Constants.MISSING_ERROR_TYPE) {
          newGroupedProblems.missing.push(problems[i]);
        }
        else if (problems[i].type === Constants.ONLINE_ERROR_TYPE) {
          newGroupedProblems.online.push(problems[i]);
        }
        else if (problems[i].type === Constants.CRITICAL_SLAVE_ERROR_TYPE) {
          newGroupedProblems.automaticBlacklist.push(problems[i]);
        }
        else if (problems[i].type === Constants.MASTER_FAULT_ERROR_TYPE) {
          newGroupedProblems.masterFault.push(problems[i]);
        }
        else if (problems[i].type === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE) {
          newGroupedProblems.fiberLowerLimitMaintenanceRequired.push(problems[i]);
        }
        else if (problems[i].type === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE) {
          newGroupedProblems.fiberLowerLimitUrgentMaintenance.push(problems[i]);
        }
        else if (problems[i].type === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
          newGroupedProblems.fiberSignalLost.push(problems[i]);
        }
      }

      let currentProblemsList = this.getCurrentProblemsList(newGroupedProblems);

      if (currentProblemsList.length > 0) {
        this.setState({
          nowMillis: Date.now(),
          lastUpdate: new Date(),
          problems: problems,
          groupedProblems: newGroupedProblems,
          currentProblemType: this.state.currentProblemType,
          currentProblemList: currentProblemsList,
        });
      }
      else {
        this.setState({
          nowMillis: Date.now(),
          lastUpdate: new Date(),
          problems: problems,
          groupedProblems: newGroupedProblems,
          currentProblemType: "",
          currentProblemList: [],
        }, () => {
          document.getElementById("no-task-selected-header").style.display = "block";
          document.getElementById("task-details").style.display = "none";
        });
      }
    }
    else {
      this.setState({
        nowMillis: Date.now(),
        lastUpdate: new Date(),
        problems: [],
        groupedProblems: {
          "retry": [],
          "diagnostic": [],
          "fault": [],
          "faultSequence": [],
          "errorConfig": [],
          "errorParam": [],
          "missing": [],
          "online": [],
          "automaticBlacklist": [],
          "masterFault": [],
          "fiberLowerLimitMaintenanceRequired": [],
          "fiberLowerLimitUrgentMaintenance": [],
          "fiberSignalLost": []
        },
        currentProblemType: "",
        currentProblemList: [],
      }, () => {
        document.getElementById("problems-list").style.display = "none";
        document.getElementById("no-problem-detected-header").style.display = "block";
        document.getElementById("no-task-selected-header").style.display = "block";
        document.getElementById("task-details").style.display = "none";
      });
    }
  }

  getCurrentProblemsList = (groupedProblems) => {
    if (this.state.currentProblemType === Constants.RETRIES_ERROR_TYPE) {
      return groupedProblems.retry;
    }
    else if (this.state.currentProblemType === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return groupedProblems.diagnostic;
    }
    else if (this.state.currentProblemType === Constants.FAULT_ERROR_TYPE) {
      return groupedProblems.fault;
    }
    else if (this.state.currentProblemType === Constants.FAULT_SEQUENCE_ERROR_TYPE) {
      return groupedProblems.faultSequence;
    }
    else if (this.state.currentProblemType === Constants.CONFIG_ERROR_TYPE) {
      return groupedProblems.errorConfig;
    }
    else if (this.state.currentProblemType === Constants.PARAM_ERROR_TYPE) {
      return groupedProblems.errorParam;
    }
    else if (this.state.currentProblemType === Constants.MISSING_ERROR_TYPE) {
      return groupedProblems.missing;
    }
    else if (this.state.currentProblemType === Constants.ONLINE_ERROR_TYPE) {
      return groupedProblems.online;
    }
    else if (this.state.currentProblemType === Constants.CRITICAL_SLAVE_ERROR_TYPE) {
      return groupedProblems.automaticBlacklist;
    }
    else if (this.state.currentProblemType === Constants.MASTER_FAULT_ERROR_TYPE) {
      return groupedProblems.masterFault;
    }
    else if (this.state.currentProblemType === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE) {
      return groupedProblems.fiberLowerLimitMaintenanceRequired;
    }
    else if (this.state.currentProblemType === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE) {
      return groupedProblems.fiberLowerLimitUrgentMaintenance;
    }
    else if (this.state.currentProblemType === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
      return groupedProblems.fiberSignalLost;
    }
    else {
      return [];
    }
  }

  solveProblem = (problem) => {
    if (problem.type === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE ||
      problem.type === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE ||
      problem.type === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE
    ) {
      fetch(Constants.REQUEST_IP_ADDRESS + "fiber/solveProblem_POST", {
        mode: "cors",
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: JSON.stringify({
          problem: problem,
          forceSolve: false
        })
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          alert(Strings.PROBLEM_CHECKED);
          this.props.onProblemSolve(false, {});
          document.getElementById(problem._id).style.display = "none";
          this.retrieveData2();
        })
        .catch(() => {
          let message = this.singleProblemErrorMessage(problem.type) + "\n";
          alert(Strings.PROBLEM_CHECK_ERROR + Strings.REASON + message);
          this.props.onProblemSolve(false, {});
        });
    } else {
      fetch(Constants.REQUEST_IP_ADDRESS + "solveProblem_POST", {
        mode: "cors",
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: JSON.stringify({
          problem: problem
        })
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          alert(Strings.PROBLEM_CHECKED);
          this.props.onProblemSolve(false, {});
          document.getElementById(problem._id).style.display = "none";
          this.retrieveData2();
        })
        .catch(() => {
          let message = this.singleProblemErrorMessage(problem.type) + "\n";
          alert(Strings.PROBLEM_CHECK_ERROR + Strings.REASON + message);
          this.props.onProblemSolve(false, {});
        });
    }
  }

  singleProblemErrorMessage = (problemType) => {
    if (problemType === Constants.RETRIES_ERROR_TYPE) {
      return Strings.S_RETRIES_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return Strings.S_DIAGNOSTIC_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.FAULT_ERROR_TYPE) {
      return Strings.S_FAULT_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.FAULT_SEQUENCE_ERROR_TYPE) {
      return Strings.S_FAULT_SEQ_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.CONFIG_ERROR_TYPE) {
      return Strings.S_CONFIG_ERROR_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.PARAM_ERROR_TYPE) {
      return Strings.S_PARAM_ERROR_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.MISSING_ERROR_TYPE) {
      return Strings.S_MISSING_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.ONLINE_ERROR_TYPE) {
      return Strings.S_ONLINE_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.CRITICAL_SLAVE_ERROR_TYPE) {
      return Strings.S_CRITICAL_SLAVE_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.MASTER_FAULT_ERROR_TYPE) {
      return Strings.S_MASTER_FAULT_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE) {
      return Strings.S_FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE) {
      return Strings.S_FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_INITIAL_ERROR_MSG;
    }
    else if (problemType === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
      return Strings.S_FIBER_SIGNAL_LOSS_INITIAL_ERROR_MSG;
    }
    else {
      return "";
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    this.retrieveTagAndUptimeData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveTagAndUptimeData, 5000) });
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState) {
    // Só tente resolver o problema quando o solve era falso e agora for true
    if (prevProps.solveProblem.solve !== this.props.solveProblem.solve
      && this.props.solveProblem.solve === true) {
      this.solveProblem(this.props.solveProblem.problem);
    }
  }

  render() {
    return (
      <div>

        <Grid style={gridStyle} columns={3} doubling>

          <Grid.Column verticalAlign="middle" style={{ paddingBottom: "0" }}>

            <Header as='h2' style={networkTagStyle}>
              <Popup position='bottom left' hoverable pinned wide="very"
                trigger={
                  <Icon name="question circle" size="small" color="teal" />
                }>
                <Popup.Content>
                  <p>{Strings.TS_EXPERT_POPUP_1}</p>
                  <p>{Strings.TS_EXPERT_POPUP_2}</p>
                  <p>{Strings.TS_EXPERT_POPUP_3}</p>
                  <p><b>{Strings.PS} </b>{Strings.TS_EXPERT_POPUP_4}</p>
                </Popup.Content>
              </Popup >
              {this.state.networkTag}
            </Header>

          </Grid.Column>

          <Grid.Column verticalAlign="middle" textAlign="center" style={{ paddingBottom: "0" }}>
            <Button
              content={Strings.EXPORT_ACTIONS_LIST}
              color="teal"
              onClick={this.generateTsExpertReport} />

            <Dimmer page active={this.state.isGenerateReportDimmerActive} >
              <Loader size="big">{Strings.GENERATING_ACTIONS_LIST_WAITING}</Loader>
            </Dimmer>

            <PDFDownloadLink
              className="download-link"
              style={pdfLinkStyle}
              document={this.state.report}
              fileName={Strings.ACTIONS_LIST_EXPORT_NAME}>
              {({ loading }) => {
                if (loading) {
                  return Strings.FINISHING;
                }
                else {
                  if (this.state.isGenerateReportDimmerActive) {
                    let downloadLink = document.getElementsByClassName("download-link")[0];
                    downloadLink.onclick = () => {
                      setTimeout(() => {
                        if (downloadLink !== null && downloadLink !== undefined) {
                          downloadLink.innerHTML = "";
                        }
                      }, 1500);
                    };
                    this.setGeneratingDimmerState(false);
                  }
                  return Strings.SAVE_ACTIONS_LIST;
                }
              }}
            </PDFDownloadLink>
          </Grid.Column>

          <Grid.Column style={{ paddingBottom: "0" }}>
            <Segment style={floatStyle} size="large" compact textAlign="center">
              <Icon color="green" name="arrow alternate circle up" />
              {Strings.TIME_ON} {this.state.uptime}
            </Segment>
          </Grid.Column>

        </Grid>

        <Grid style={gridStyle} columns={2} doubling>

          <Grid.Column>
            <Segment style={leftSegmentStyle}>

              <Header as='h2' textAlign="center" color="teal">
                {Strings.EVENTS_LIST}
              </Header>
              <Divider clearing />

              <Segment id="problems-list" style={listSegmentStyle} basic>
                <List size="medium" animated divided style={listStyle}>
                  {this.getListItem(Constants.RETRIES_ERROR_TYPE, this.state.groupedProblems.retry)}
                  {this.getListItem(Constants.DIAGNOSTIC_ERROR_TYPE, this.state.groupedProblems.diagnostic)}
                  {this.getListItem(Constants.FAULT_ERROR_TYPE, this.state.groupedProblems.fault)}
                  {this.getListItem(Constants.FAULT_SEQUENCE_ERROR_TYPE, this.state.groupedProblems.faultSequence)}
                  {this.getListItem(Constants.CONFIG_ERROR_TYPE, this.state.groupedProblems.errorConfig)}
                  {this.getListItem(Constants.PARAM_ERROR_TYPE, this.state.groupedProblems.errorParam)}
                  {this.getListItem(Constants.MISSING_ERROR_TYPE, this.state.groupedProblems.missing)}
                  {this.getListItem(Constants.ONLINE_ERROR_TYPE, this.state.groupedProblems.online)}
                  {this.getListItem(Constants.CRITICAL_SLAVE_ERROR_TYPE, this.state.groupedProblems.automaticBlacklist)}
                  {this.getListItem(Constants.MASTER_FAULT_ERROR_TYPE, this.state.groupedProblems.masterFault)}
                  {this.getListItem(Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE, this.state.groupedProblems.fiberLowerLimitMaintenanceRequired)}
                  {this.getListItem(Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE, this.state.groupedProblems.fiberLowerLimitUrgentMaintenance)}
                  {this.getListItem(Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE, this.state.groupedProblems.fiberSignalLost)}
                </List>
              </Segment>

              <Header
                textAlign="center"
                style={noTaskHeaderSelectedStyle}
                id="no-problem-detected-header"
                as='h2'
                icon
                color="teal">
                <Icon name="check circle" color="teal" />
                {Strings.NO_PROBLEM_DETECTED}
                <Header.Subheader>
                  <p>{Strings.NO_EVENTS_TO_BE_ANALYZED}</p>
                </Header.Subheader>
              </Header>

            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment style={rightSegmentStyle}>

              <Header as='h2' textAlign="center" color="teal">
                {Strings.ACTIONS}
              </Header>
              <Divider clearing />

              <Header
                textAlign="center"
                style={noTaskHeaderSelectedStyle}
                id="no-task-selected-header"
                as="h2"
                icon
                color="teal">
                <Icon name='edit outline' color="teal" />
                {Strings.NO_EVENT_SELECTED}
                <Header.Subheader>
                  {Strings.CHOOSE_AN_EVENT}
                </Header.Subheader>
              </Header>

              <Segment id="task-details" style={taskSegmentStyle}>

                <Button
                  size="tiny"
                  circular
                  icon="times"
                  onClick={this.handleCloseButtonClick} />

                {this.getActions()}
                {this.getProblemCards()}

              </Segment>

            </Segment>

          </Grid.Column>

        </Grid>

        <div style={lastUpdateContainerStyle}>
          <div>
            <p>
              <b>{Strings.LAST_UPDATED}</b>
              {this.state.lastUpdate.toLocaleString("pt-BR")}
              {Strings.THIS_COMPUTER_TIME}
            </p>
          </div>
          <div>
            <Button
              style={{ marginLeft: "8px" }}
              circular
              color="teal"
              icon="refresh"
              onClick={this.retrieveData2} />
          </div>
        </div>

      </div >
    );
  }
}

const mapStateToProps = state => ({
  solveProblem: state.solveProblem,
});

const mapActionsToProps = {
  onProblemSolve: solveProblemAction
};

const gridStyle = {
  marginLeft: "2vw",
  marginRight: "2vw"
};

const listStyle = {
  marginLeft: "24px",
  marginRight: "24px"
};

const leftSegmentStyle = {
  height: "66vh"
};

const rightSegmentStyle = {
  height: "66vh"
};

const listSegmentStyle = {
  display: "none",
  overflowY: "scroll",
  height: "52vh"
};

const taskSegmentStyle = {
  display: "none",
  overflowY: "scroll",
  height: "52vh"
};

const noTaskHeaderSelectedStyle = {
  marginTop: "14vh"
};

const listContentStyle = {
  marginTop: "4px",
  marginBottom: "4px"
};

const pdfLinkStyle = {
  marginLeft: "8px"
};

const networkTagStyle = {
  color: "#576577"
};

const floatStyle = {
  float: "right",
  textAlign: "right"
};

const lastUpdateContainerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "8px"
};

export default connect(mapStateToProps, mapActionsToProps)(withRouter(TSExpert));
